export default __webpack_public_path__ + "static/small-business-accomplishment-4-cb127f41b9ab40a21fee2936f5047c1d.webp";